import request from '../utils/backend';
import env from '../environment';
import moment from 'moment';
import * as actions from '../constants/timesheetActions';
import * as events from '../constants/eventActions';

const timesheetActions = {

    approve(timesheet) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTimesheetState());

            request
                .post(env.tashi + '/timesheets/' + timesheet.id + '/approve')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.approveTimesheet({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "approve timesheet" }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.approveTimesheet({ status: "success", data: timesheetID }));
                        dispatch(events.pushSuccessEvent({ data: "approve timesheet" }));
                    } else {
                        dispatch(actions.approveTimesheet({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "approve timesheet" }));
                    }
                });
        };
    },

    // TODO create backend logic
    cmlmLoadByWeek(week) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTimesheetState());

            request
                .get(env.tashi + '/timesheets/search/cmlm_findByWeek')
                .query({
                    week: week
                })
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.cmlmLoadTimesheetsByWeek({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.timesheets : null;

                    if (data) {
                        dispatch(actions.cmlmLoadTimesheetsByWeek({ status: "success", data: data }));
                    } else {
                        dispatch(actions.cmlmLoadTimesheetsByWeek({ status: "success", data: [] }));
                    }
                });
        };
    },

    delete(timesheetID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTimesheetState());

            request
                .post(env.tashi + '/timesheets/' + timesheetID + '/delete')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.deleteTimesheet({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "delete timesheet" }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.deleteTimesheet({ status: "success", data: timesheetID }));
                        dispatch(events.pushSuccessEvent({ data: "delete timesheet" }));
                    } else {
                        dispatch(actions.deleteTimesheet({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "delete timesheet" }));
                    }
                });
        };
    },

    editStatus(timesheet, timesheetStatus) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTimesheetState());

            request
                .post(env.tashi + '/timesheets/' + timesheet.id + '/setStatus')
                .query({
                    status: timesheetStatus
                })
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.editTimesheetStatus({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "edit timesheetstatus " }));
                        return;
                    }

                    if (res.ok) {
                        let data = {timesheet: timesheet, status: timesheetStatus};
                        dispatch(actions.editTimesheetStatus({ status: "success", data: data }));
                        dispatch(events.pushSuccessEvent({ data: "edit timesheetstatus " }));
                    } else {
                        dispatch(actions.editTimesheetStatus({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "edit timesheetstatus " }));
                    }
                });
        };
    },

    loadByUserWeek(user, week) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTimesheetState());

            request
                .get(env.tashi + '/timesheets/search/findByUserAndWeek')
                .query({
                    user: user.id,
                    week: week
                })
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadTimesheetsByUserAndWeek({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text) ? [JSON.parse(res.text)] : null;

                    if (data) {
                        dispatch(actions.loadTimesheetsByUserAndWeek({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadTimesheetsByUserAndWeek({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadByWeek(week) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTimesheetState());

            request
                .get(env.tashi + '/timesheets/search/findByWeek')
                .query({
                    week: week
                })
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadTimesheetsByWeek({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.timesheets : null;

                    if (data) {
                        dispatch(actions.loadTimesheetsByWeek({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadTimesheetsByWeek({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmoLoadByYear(year) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTimesheetState());

            request
                .get(env.tashi + '/timesheets/search/pmo_findByYear')
                .query({
                    year: year
                })
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmoLoadTimesheetsByYear({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.timesheets : null;

                    if (data) {
                        dispatch(actions.pmoLoadTimesheetsByYear({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmoLoadTimesheetsByYear({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmoLoadByRange(year, part) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTimesheetState());

            moment.updateLocale('en', {
                week: { doy: 4, dow: 1 }
            });

            let from = moment(year + '-' + part, 'YYYY-Q').startOf('isoweek').format('YYYYWW');
            let to = moment(year + '-' + part, 'YYYY-Q').add(1, 'Q').subtract(1, 'w').format('YYYYWW');

            request
                .get(env.tashi + '/timesheets/search/pmo_findByRange')
                .query({
                    from: from
                    , to: to
                })
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmoLoadTimesheetsByRange({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.overviewTimesheets : null;

                    if (data) {
                        dispatch(actions.pmoLoadTimesheetsByRange({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmoLoadTimesheetsByRange({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmoUnlock(timesheet) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTimesheetState());

            request
                .post(env.tashi + '/timesheets/' + timesheet.id + '/pmo_unlock')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.setTimesheetStatusToEntry({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "PMO unlock timesheet" }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.setTimesheetStatusToEntry({ status: "success", data: timesheet }));
                        dispatch(events.pushSuccessEvent({ data: "PMO unlock timesheet" }));
                    } else {
                        dispatch(actions.setTimesheetStatusToEntry({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "PMO unlock timesheet" }));
                    }
                });
        };
    },

    reject(timesheetID, approvedHoursID, message, rejecter, rejectedAt) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTimesheetState());

            request
                .post(env.tashi + '/timesheets/' + timesheetID + '/reject')
                .query({
                    hoursId: approvedHoursID,
                    message: message
                })
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.rejectApprovedHours({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "reject timesheet" }));
                        return;
                    }

                    if (res.ok) {
                        let data = {timesheetID, approvedHoursID, message, rejecter, rejectedAt};
                        dispatch(actions.rejectApprovedHours({ status: "success", data: data }));
                        dispatch(events.pushSuccessEvent({ data: "reject timesheet" }));
                    } else {
                        dispatch(actions.rejectApprovedHours({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "reject timesheet" }));
                    }
                });
        };
    },

    reopen(timesheet) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTimesheetState());

            request
                .post(env.tashi + '/timesheets/' + timesheetID + '/reopen')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.setTimesheetStatusToEntry({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "reopen timesheet" }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.setTimesheetStatusToEntry({ status: "success", data: timesheet }));
                        dispatch(events.pushSuccessEvent({ data: "reopen timesheet" }));
                    } else {
                        dispatch(actions.setTimesheetStatusToEntry({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "reopen timesheet" }));
                    }
                });
        };
    },

    submit(timesheet) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTimesheetState());

            request
                .post(env.tashi + '/timesheets/' + timesheet.id + '/submit')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.submitTimesheet({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "submit timesheet" }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.submitTimesheet({ status: "success", data: timesheet }));
                        dispatch(events.pushSuccessEvent({ data: "submit timesheet" }));
                    } else {
                        dispatch(actions.submitTimesheet({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "submit timesheet" }));
                    }
                });
        };
    }

};

export default timesheetActions;



/** WEBPACK FOOTER **
 ** ./src/app/actions/timesheetActionCreators.js
 **/